module.exports = __webpack_public_path__ + "static/media/night_icon_dark.4a04e73d.svg";